import React from 'react';
import { Button } from '@pwc/pwc-deals-ui';
import FormBottomActionsContainer from '../../common/components/FormBottomActionsContainer';
import SupportTicketLink from '../../../../../common/components/SupportTicketLink';

const RequestError = ({ onTryAgainClick }) => {
  return (
    <>
      <p>There was a problem submitting your request.</p>
      <p>
        If the issue continues, please <SupportTicketLink />
        {'. '}
      </p>
      <br />
      <div className="separator" />
      <FormBottomActionsContainer>
        <Button
          className="button-block sm"
          type="button"
          data-testid="try-again-button"
          onClick={onTryAgainClick}
        >
          Try Again
        </Button>
      </FormBottomActionsContainer>
    </>
  );
};

export default RequestError;
